// components/ui/FormField.tsx
import React from 'react';
import { FormFieldProps } from '../../types/index';

const FormField: React.FC<FormFieldProps> = ({
                                               label,
                                               name,
                                               type = 'text',
                                               required = false,
                                               as,
                                               options,
                                               placeholder
                                             }) => (
  <div className="mb-6">
    <label htmlFor={name} className="block text-sm font-medium text-gray-700 mb-1">
      {label}
      {required && <span className="text-red-500">*</span>}
    </label>
    {as === 'textarea' ? (
      <textarea
        id={name}
        name={name}
        rows={4}
        required={required}
        placeholder={placeholder}
        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-lime-500 focus:border-lime-500 sm:text-sm"
      />
    ) : as === 'select' ? (
      <select
        id={name}
        name={name}
        required={required}
        className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-lime-500 focus:border-lime-500 sm:text-sm rounded-md"
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options?.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
      </select>
    ) : (
      <input
        type={type}
        id={name}
        name={name}
        required={required}
        placeholder={placeholder}
        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-lime-500 focus:border-lime-500 sm:text-sm"
      />
    )}
  </div>
);

export default FormField;
